import React from 'react';

// Hooks import [제거 금지]
import useLockScroll from 'hooks/useLockScroll';

/**
 * 재사용 가능한 확인 모달
 * @param {boolean} isOpen - 모달이 열려있는지 여부
 * @param {function} onClose - 닫기/취소 버튼 클릭 시
 * @param {function} onConfirm - 확인 버튼 클릭 시
 * @param {string} title - 모달 제목
 * @param {string} message - 모달 본문 메시지
 * @param {boolean} showCancel - 취소 버튼 표시 여부 (기본값: true) [추가]
 */
function ConfirmModal({ isOpen, onClose, onConfirm, title, message, showCancel = true, isLoading = false }) {

    // 모달이 열려있을 때만 body 스크롤 잠금
    useLockScroll(isOpen);

    // isOpen이 false이면 아무것도 렌더링하지 않음
    if (!isOpen) {
        return null;
    }

    return (
        // 모달 배경 (Overlay)
        <div style={modalStyles.overlay} onClick={!isLoading ? onClose : undefined}>
            {/* 모달 컨텐츠 (배경 클릭 시 닫히지 않도록 이벤트 전파 차단) */}
            <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>

                {/* 1. 제목 */}
                <h3 style={modalStyles.title}>{title}</h3>

                {/* 2. 메시지 */}
                <p style={modalStyles.message}>{message}</p>

                {/* 3. 버튼 그룹 */}
                <div style={modalStyles.buttonGroup}>
                    {/* showCancel이 true일 때만 취소 버튼 렌더링 */}
                    {showCancel && (
                        <button
                            style={{ ...modalStyles.button, ...modalStyles.cancelButton }}
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            취소
                        </button>
                    )}
                    <button
                        style={{
                            ...modalStyles.button,
                            ...modalStyles.confirmButton,
                            opacity: isLoading ? 0.7 : 1,
                            cursor: isLoading ? 'not-allowed' : 'pointer'
                        }}
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? '처리 중...' : '확인'}
                    </button>
                </div>
            </div>
        </div>
    );
}

// 모달 전용 스타일
const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)', // 반투명 검은색
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000, // 최상단에 표시
    },
    content: {
        background: '#1B1931', // 흰색 배경
        padding: '24px',
        borderRadius: '12px',
        width: '300px', // 모달 너비
        minHeight: '135px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        textAlign: 'center',
        color: '#FFFFFF', // 검은색 텍스트
    },
    title: {
        margin: '0 0 12px 0',
        fontSize: '18px',
        fontWeight: 'bold',
    },
    message: {
        margin: '0 0 24px 0',
        fontSize: '16px',
        lineHeight: 1.5,
        whiteSpace: 'pre-wrap', // 줄바꿈(\n)이 적용되도록
    },
    buttonGroup: {
        display: 'flex',
        gap: '12px',
    },
    button: {
        flex: 1, // 버튼이 1:1 비율로 꽉 차게
        border: 'none',
        borderRadius: '6px',
        padding: '12px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    cancelButton: {
        background: '#E0E0E0', // 회색
        color: '#333333',
    },
    confirmButton: {
        // background: '#FF5252', // 붉은색 (확인)
        background: 'linear-gradient(90deg, #8052FF 0%, #0231FB 100%)', // 붉은색 (확인)
        color: 'white',
    },
};

export default ConfirmModal;